module.exports = "<ng-content select=\"[left]\"></ng-content>\n\n<ng-content select=\"[right]\"></ng-content>\n"